var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.0001C17.5053 13.4564 15.1479 16.4689 11.7916 17.2945C8.43535 18.1202 4.94941 16.5453 3.35062 13.4809C1.75183 10.4165 2.45424 6.65639 5.05148 4.37588C7.64871 2.09536 11.4681 1.88509 14.3 3.86673L14.2083 3.60007C14.0611 3.15134 14.3054 2.66818 14.7542 2.5209C15.2029 2.37362 15.6861 2.618 15.8333 3.06673L16.6667 5.56673C16.7505 5.82096 16.7071 6.09998 16.55 6.31673C16.3861 6.54757 16.1162 6.67938 15.8333 6.66673H13.3333C12.8731 6.66673 12.5 6.29364 12.5 5.8334C12.5062 5.47151 12.7453 5.15498 13.0917 5.05007C10.8369 3.64086 7.91458 3.93467 5.98551 5.76451C4.05643 7.59434 3.60884 10.4971 4.89711 12.8231C6.18538 15.149 8.8835 16.3095 11.458 15.6449C14.0325 14.9803 15.8318 12.6589 15.8333 10.0001C15.8333 9.53983 16.2064 9.16673 16.6667 9.16673C17.1269 9.16673 17.5 9.53983 17.5 10.0001Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.bff9b1e06d0d472f4076bef9eabdb06f.svg";
export { ForwardRef as ReactComponent };